import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export const Pagination = ({ currentPage, totalPages, onPageChange, className }) => {
	return (
		<div className={cn('flex items-center justify-end my-2', className)}>
			{totalPages > 1 && (
				<div className="flex items-center space-x-1">
					{currentPage !== 1 && (
						<Button
							variant="outline"
							size="icon"
							className="!min-h-8 !min-w-8 !p-0"
							onClick={() => onPageChange(currentPage - 1)}
						>
							<ChevronLeft className="h-5 w-5" />
						</Button>
					)}

					{Array.from({ length: totalPages }).map((_, index) => (
						<Button
							key={index}
							variant={currentPage === index + 1 ? 'default' : 'outline'}
							className="!min-h-8 !min-w-8 !p-0"
							onClick={() => onPageChange(index + 1)}
						>
							<span className="text-sm">{index + 1}</span>
						</Button>
					))}
					{currentPage !== totalPages && (
						<Button
							variant="outline"
							className="!min-h-8 !min-w-8 !p-0"
							onClick={() => onPageChange(currentPage + 1)}
						>
							<ChevronRight className="h-5 w-5" />
						</Button>
					)}
				</div>
			)}
		</div>
	);
};
